import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-eca9091c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "drapper-container" }
const _hoisted_2 = { class: "ant-upload-drag-icon" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ant-upload-text" }, "点击或拖动文件到虚线框内上传", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ant-upload-hint" }, "支持xls,xlsx类型的文件", -1))
const _hoisted_5 = {
  key: 0,
  class: "loading-container"
}

import { ref } from "vue";
import { CloudUploadOutlined } from "@ant-design/icons-vue";
import { FileRecord } from "@/core/services/file-upload.interface";
import { FileUploadService } from "@/core";
import { getFileExt } from "@/utils";
import { message } from "ant-design-vue";


import { defineComponent } from "vue";
const __default__ = defineComponent({
  name: "UploadArea",
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  calcLoading: {
    type: Boolean,
    default: false,
  },
},
  emits: ["getFileUrl", "update:calcLoading"],
  setup(__props, { emit }) {

const props = __props





const beforeUpload = (file) => {
  if (file.size > 10 * 1024 * 1024) {
    message.warning(`单个文件不得超过10M`);
    return false;
  }
};

const fileList = ref([]);

const customRequest = async ({ file }) => {
  emit("update:calcLoading", true);
  const url = await FileUploadService.uploadToOss(file).catch(() =>
    emit("update:calcLoading", false)
  );
  const fileRecord = new FileRecord();
  fileRecord.merge({
    uid: file.uid,
    name: file.name,
    suffix: getFileExt(file.name),
    size: file.size,
    url,
  });
  emit("getFileUrl", url);
};

return (_ctx: any,_cache: any) => {
  const _component_a_upload_dragger = _resolveComponent("a-upload-dragger")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_upload_dragger, {
      "file-list": fileList.value,
      "onUpdate:file-list": _cache[0] || (_cache[0] = ($event: any) => ((fileList).value = $event)),
      name: "file",
      multiple: false,
      "before-upload": beforeUpload,
      "custom-request": customRequest,
      "show-upload-list": false,
      accept: ".xls,.xlsx",
      class: "upload-area"
    }, {
      default: _withCtx(() => [
        _createElementVNode("p", _hoisted_2, [
          _createVNode(_unref(CloudUploadOutlined), {
            style: {"color":"#4372fc"},
            class: "theme-color"
          })
        ]),
        _hoisted_3,
        _hoisted_4
      ]),
      _: 1
    }, 8, ["file-list"]),
    (__props.calcLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(_component_a_spin)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})